module.exports = __webpack_public_path__ + "img/next.36dbec5c.png";